import { render, staticRenderFns } from "./RechargeRecord.vue?vue&type=template&id=966e1712&scoped=true"
import script from "./RechargeRecord.vue?vue&type=script&lang=js"
export * from "./RechargeRecord.vue?vue&type=script&lang=js"
import style0 from "./RechargeRecord.vue?vue&type=style&index=0&id=966e1712&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_9104b087796de0a589f26e8ae34b49bc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966e1712",
  null
  
)

export default component.exports